import React from 'react';
import { Box, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export const ATPLBackButton = ( { onClick } ) => {
  return (
    <Box
      onClick={ onClick }
      sx={ {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        color: '#F15C30',
        width: 'fit-content'
      } }
    >
      <Box
        sx={ {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(241, 92, 48, 0.1)', // Light background with 10% opacity of #F15C30
          borderRadius: '50%',
          width: 24,
          height: 24
        } }
      >
        <Box sx={ { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } }>
          <ArrowBackIosNewIcon sx={ { fontSize: 12 } } />
        </Box>
      </Box>
      <Typography
        sx={ {
          fontSize: 15,
          fontWeight: 500,
          color: '#F15C30'
        } }
      >
        Back
      </Typography>
    </Box>
  );
};
